import { z } from 'zod'

export const countrySchema = z
  .enum([
    'Belgien',
    'Dänemark',
    'Deutschland',
    'Frankreich',
    'Griechenland',
    'Großbritannien',
    'Luxemburg',
    'Österreich',
    'Schweiz',
  ])
  .default('Deutschland')
  .describe('Land')
